import { Bookstore } from './bookstore';
import { CitationStyle } from './citation-style';
import { Importance } from './importance';
import { License } from './license';
import { ListAccess } from './list-access';
import { Period } from './period';
import { Tag } from './tag';
import { Tenant } from './tenant';

export type TenantOrNull = Tenant | null;

export interface TenantState {
  tenant: TenantOrNull;
}

export const TENANT_INITIAL_STATE = {
  tenant: null,
};

export const getTenant = (state: TenantState): TenantOrNull => state.tenant;

export const getActiveTimePeriods = (state: TenantOrNull): Period[] | null =>
  state && state.periods
    ? state.periods.filter(period => period.isActive !== false)
    : null;

export const getLicenses = (state: TenantOrNull): License[] | null =>
  state && state.licenses;

export const getDefaultListAccess = (state: TenantOrNull): ListAccess | null =>
  state && state.default_list_access;

export const getBookstores = (state: TenantOrNull): Bookstore[] | null =>
  state && state.bookstores.filter(bookstore => bookstore.isEnabled);

export const getActiveImportances = (
  state: TenantOrNull,
): Importance[] | null =>
  state && state.importances
    ? state.importances.filter(importances => importances.isActive !== false)
    : null;

export const getCitationStyles = (
  state: TenantOrNull,
): CitationStyle[] | null => state && state.citation_styles;

export const getDefaultLocale = (state: TenantOrNull): string | null =>
  state && state.default_locale;

export const getActiveLocales = (state: TenantOrNull): string[] | null =>
  state && state.active_locales;

export const getActiveTags = (state: TenantOrNull): Tag[] | null =>
  state && state.tags ? state.tags.filter(tags => tags.isActive) : null;
